// RequestReversionModal comment:　MAXLENGTH　Validation
export const MAXLENGTH = 1000;

// 差戻
export const REVERSION = 'Reversion';

// 差戻依頼
export const REVERSION_REQUEST = 'ReversionRequest';
